export default "__VITE_ASSET__55fbe8b6__"